// @flow

// Types
import type {
  ImportJobsPopupOperationsById,
} from 'hfty-operator-import-jobs-popup/types'

// Constants
import {
  TREE,
  BRANCH,
} from 'hfty-model-import-jobs-popup'

// Utils
import traverse from 'fc-utils/traverse'

type ImportJobsPopupOperationsSelector = (state: Object) => ImportJobsPopupOperationsById

export default (traverse([TREE, BRANCH]): ImportJobsPopupOperationsSelector)
